document.addEventListener("DOMContentLoaded", () => {
  const safePlayMedia = (media) => {
    if (!media || typeof media.play !== "function") return;

    const playPromise = media.play();

    if (playPromise !== undefined) {
      playPromise.catch((err) => console.log("Play blocked:", err));
    }
  };

  const controlIframePlayback = (iframe, action) => {
    if (!iframe || !iframe.contentWindow) return;

    try {
      if (iframe.src.includes("youtube")) {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            event: "command",
            func: action === "pause" ? "pauseVideo" : "playVideo",
          }),
          "*"
        );
      }

      if (iframe.src.includes("vimeo")) {
        iframe.contentWindow.postMessage(
          JSON.stringify({
            method: action,
          }),
          "*"
        );
      }
    } catch (error) {
      console.log("iframe playback error", error);
    }
  };

  const scheduleIdle = (callback, timeout = 1500) => {
    if ("requestIdleCallback" in window) {
      window.requestIdleCallback(callback, { timeout });
      return;
    }

    window.setTimeout(callback, 250);
  };

  const ensureSwiperLa = (callback) => {
    const loadSwiper =
      typeof window.loadSwiperLa === "function"
        ? window.loadSwiperLa
        : () => Promise.resolve(window.Swiper);

    return loadSwiper()
      .then((SwiperCtor) => {
        if (!SwiperCtor) return null;
        return callback(SwiperCtor);
      })
      .catch((error) => {
        console.log("Swiper load error:", error);
        return null;
      });
  };

  const runWhenNear = (target, callback, rootMargin = "700px 0px") => {
    const element =
      typeof target === "string" ? document.querySelector(target) : target;

    if (!element) return;

    let started = false;
    const start = () => {
      if (started) return;

      started = true;
      scheduleIdle(callback);
    };

    if (element.getBoundingClientRect().top < window.innerHeight + 700) {
      start();
      return;
    }

    if ("IntersectionObserver" in window) {
      const observer = new IntersectionObserver(
        (entries) => {
          if (!entries.some((entry) => entry.isIntersecting)) return;

          observer.disconnect();
          start();
        },
        { rootMargin }
      );

      observer.observe(element);
      return;
    }

    start();
  };

  const bodyProduct = document.body;
  const zoomItems = document.querySelector(".product-zoom-la");
  const imageZoom = document.querySelectorAll(".image_product_unset img");
  const closeZoomModal = document.querySelector(".close_zoom_button-la");
  const itemProduct = document.querySelectorAll(
    ".media-product-items-la, .mobile-media-product-items-la"
  );
  const textDescription = document.querySelector(".text-description-la");
  const collapsibleLayer = document.querySelector("[data-product-collapsible-layer]");
  const collapsibleBtn = document.querySelectorAll("[data-product-collapsible-trigger]");
  const closeButton = document.querySelectorAll("[data-product-collapsible-close]");
  const collapsibleModals = document.querySelectorAll("[data-product-collapsible-modal]");
  const productSticky = document.querySelector(".left-section-info-la");

  const videoIcons = document.querySelectorAll('.icon-video-play-parent-la');
  const shouldAutoplayDesktopMedia =
    window.innerWidth > 1024 || /iPhone|iPad|iPod/i.test(navigator.userAgent);

  const isRenderedElement = (element) =>
    !!(element && (element.offsetParent || element.getClientRects().length));

  let mobileImagesSliderSwiper = null;
  let mobileImagesSliderPromise = null;

  const bindMobileMediaSlideEvents = (swiper) => {
    if (!swiper || swiper.__mobileMediaEventsBound) return;
    swiper.__mobileMediaEventsBound = true;

    swiper.on("slideChangeTransitionEnd", function () {
      const slides = this.slides;

      slides.forEach((slide) => {
        const video = slide.querySelector("video");
        const playIcon = slide.querySelector(".play-icon-mobile");
        const pauseIcon = slide.querySelector(".pause-icon-mobile");

        if (!playIcon || !pauseIcon) return;

        if (slide.classList.contains("swiper-slide-active")) {
          if (video) {
            safePlayMedia(video);
            playIcon.style.display = "none";
            pauseIcon.style.display = "inline-block";
          } else {
            playIcon.style.display = "inline-block";
            pauseIcon.style.display = "none";
          }
        } else {
          if (video) video.pause();
          playIcon.style.display = "inline-block";
          pauseIcon.style.display = "none";
        }
      });
    });
  };

  const initMobileImagesSlider = () => {
    if (mobileImagesSliderSwiper) return Promise.resolve(mobileImagesSliderSwiper);

    const slider = document.querySelector(".mobile-media-product-la");
    if (!slider) return Promise.resolve(null);

    if (!mobileImagesSliderPromise) {
      mobileImagesSliderPromise = ensureSwiperLa((SwiperCtor) => {
        if (mobileImagesSliderSwiper) return mobileImagesSliderSwiper;

        mobileImagesSliderSwiper = new SwiperCtor(slider, {
          navigation: {
            nextEl: ".swiper-button-next",
            prevEl: ".swiper-button-prev",
          },
          pagination: {
            el: ".swiper-pagination",
          },
          zoom: true,
        });

        if (window.innerWidth <= 834) {
          bindMobileMediaSlideEvents(mobileImagesSliderSwiper);
        }

        return mobileImagesSliderSwiper;
      });
    }

    return mobileImagesSliderPromise;
  };

  const setupDesktopVideoWrapper = (wrapper) => {
    const video = wrapper.querySelector("video");
    const iframe = wrapper.querySelector("iframe");
    const btn = wrapper.querySelector(".icon-video-play-parent-desktop-la");

    if (!btn) return;

    if (video && !video.paused) {
      btn.classList.add("playing");
    }

    btn.addEventListener("click", function (e) {
      e.preventDefault();
      e.stopPropagation();

      const isPlaying = btn.classList.contains("playing");

      if (video) {
        if (isPlaying) {
          video.pause();
        } else {
          video.muted = true;
          safePlayMedia(video);
        }
      }

      if (iframe) {
        controlIframePlayback(iframe, isPlaying ? "pause" : "play");
      }

      btn.classList.toggle("playing");
    });
  };

  const autoplayDesktopVideoWrapper = (wrapper) => {
    const video = wrapper.querySelector("video");
    const iframe = wrapper.querySelector("iframe");
    const btn = wrapper.querySelector(".icon-video-play-parent-desktop-la");

    if (video) {
      video.muted = true;
      safePlayMedia(video);
    }

    if (iframe) {
      controlIframePlayback(iframe, "play");
    }

    btn?.classList.add("playing");
  };

  document.querySelectorAll(".video-wrapper").forEach((wrapper) => {
    setupDesktopVideoWrapper(wrapper);

    if (
      shouldAutoplayDesktopMedia &&
      wrapper.closest(".media-product-items-la") &&
      isRenderedElement(wrapper)
    ) {
      runWhenNear(wrapper, () => autoplayDesktopVideoWrapper(wrapper), "200px 0px");
    }
  });
 if (window.innerWidth <=  834) {
  videoIcons.forEach(iconWrapper => {
    iconWrapper.addEventListener('click', e => {
      e.preventDefault();
      e.stopPropagation();

      initMobileImagesSlider().then((swiper) => {
      if (!swiper) return;
      const slides = swiper.slides;

      const videoIndex = Array.from(slides).findIndex(slide =>
        slide.dataset.mediaType === 'video' || slide.dataset.mediaType === 'external_video'
      );
      if (videoIndex === -1) return;

      const firstIcon = document.querySelector('.play-icon-only-first-index');
      if (firstIcon) firstIcon.style.display = 'none';

      if (swiper.activeIndex !== videoIndex) {
        swiper.slideTo(videoIndex);

        const onSlide = () => {
          const activeSlide = swiper.slides[swiper.activeIndex];
          const video = activeSlide.querySelector('video');
          const playIcon = activeSlide.querySelector('.play-icon-mobile');
          const pauseIcon = activeSlide.querySelector('.pause-icon-mobile');

          if (video) safePlayMedia(video);
          if (playIcon && pauseIcon) {
            playIcon.style.display = 'none';
            pauseIcon.style.display = 'inline-block';
          }

          swiper.off('slideChangeTransitionEnd', onSlide);
        };

        swiper.on('slideChangeTransitionEnd', onSlide);
        return;
      }

      const activeSlide = slides[swiper.activeIndex];
      const video = activeSlide.querySelector('video');
      const playIcon = activeSlide.querySelector('.play-icon-mobile');
      const pauseIcon = activeSlide.querySelector('.pause-icon-mobile');

      if (!video) return;

      if (!video.paused) {
        video.pause();
        if (playIcon && pauseIcon) {
          playIcon.style.display = 'inline-block';
          pauseIcon.style.display = 'none';
        }
      } else {
        safePlayMedia(video);
        if (playIcon && pauseIcon) {
          playIcon.style.display = 'none';
          pauseIcon.style.display = 'inline-block';
        }
      }
      });
    });
  });
}
  const wrappers = document.querySelectorAll(".image_product_unset");

  wrappers.forEach(wrapper => {
    const video = wrapper.querySelector("video");
    const iframe = wrapper.querySelector("iframe");
    const icon = wrapper.querySelector(".icon-video-state-la");

    if (!video && !iframe || !icon) return;

    icon.classList.remove("playing");

    wrapper.classList.add("video-active-la");
    setTimeout(() => {
      wrapper.classList.remove("video-active-la");
    }, 1500);

    wrapper.addEventListener("click", () => {
      let isPlaying = true;

      if (video) {
        isPlaying = !video.paused;

        if (isPlaying) video.pause();
        else safePlayMedia(video);
      }

      if (iframe) {
        if (iframe.src.includes("vimeo")) {
          iframe.contentWindow.postMessage(JSON.stringify({
            method: isPlaying ? "pause" : "play"
          }), "*");
        }

        if (iframe.src.includes("youtube")) {
          iframe.contentWindow.postMessage(JSON.stringify({
            event: "command",
            func: isPlaying ? "pauseVideo" : "playVideo"
          }), "*");
        }
      }

      if (isPlaying) {
        icon.classList.add("playing");
      } else {
        icon.classList.remove("playing");
      }

      wrapper.classList.remove("video-active-la");
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          wrapper.classList.add("video-active-la");

          setTimeout(() => {
            wrapper.classList.remove("video-active-la");
          }, 1500);
        });
      });
    });
  });

  runWhenNear(".swiper-you-my-slider-also-container-la", () => {
    ensureSwiperLa((SwiperCtor) => new SwiperCtor(".swiper-you-my-slider-also-container-la", {
      slidesPerView: "auto",
      spaceBetween: 8,
      navigation: {
        nextEl: ".swiper-button-next-also-with-la",
        prevEl: ".swiper-button-prev-also-with-la",
      },
      pagination: {
        el: ".swiper-pagination-also-with-la",
      },
    }));
  });

  runWhenNear(".best-seller-slider", () => {
    ensureSwiperLa((SwiperCtor) => new SwiperCtor(".best-seller-slider", {
      slidesPerView: "auto",
      spaceBetween: 8,
      loop: true,
      navigation: {
        nextEl: ".swiper-button-next-best-la",
        prevEl: ".swiper-button-prev-best-la",
      },
      pagination: {
        el: ".swiper-paginetion-best-la",
      },
    }));
  });
  if (productSticky) {
    let lastScrollTop = 0;
    let stickyScrollFrame = 0;

    window.addEventListener(
      "scroll",
      () => {
        if (stickyScrollFrame) return;

        stickyScrollFrame = window.requestAnimationFrame(() => {
          const currentScrollTop =
            window.pageYOffset || document.documentElement.scrollTop;

          if (currentScrollTop > lastScrollTop) {
            productSticky.classList.remove("product-sticky-la");
          } else {
            productSticky.classList.add("product-sticky-la");
          }

          lastScrollTop = currentScrollTop <= 0 ? 0 : currentScrollTop;
          stickyScrollFrame = 0;
        });
      },
      { passive: true }
    );
  }


  let collapsibleScrollTop = 0;
  let activeCollapsibleTrigger = null;
  let productPageLockedByCollapsible = false;

  const findCollapsibleModal = (id) => {
    return Array.from(collapsibleModals).find((modal) => {
      return modal.dataset.productCollapsibleModal === id;
    });
  };

  const isProductCollapsibleOpen = () => {
    return Array.from(collapsibleModals).some((modal) => {
      return modal.classList.contains("active-container-la");
    });
  };

  const lockProductPage = () => {
    if (bodyProduct.style.position === "fixed") return;

    collapsibleScrollTop = window.scrollY || document.documentElement.scrollTop;
    bodyProduct.style.top = `-${collapsibleScrollTop}px`;
    bodyProduct.style.position = "fixed";
    bodyProduct.style.width = "100%";
    bodyProduct.style.overflowY = "scroll";
    productPageLockedByCollapsible = true;
  };

  const unlockProductPage = () => {
    if (!productPageLockedByCollapsible) return;

    bodyProduct.style.position = "";
    bodyProduct.style.top = "";
    bodyProduct.style.width = "";
    bodyProduct.style.overflowY = "";
    window.scrollTo(0, collapsibleScrollTop);
    productPageLockedByCollapsible = false;
  };

  const closeCollapsible = ({ restoreScroll = true } = {}) => {
    const wasOpen = isProductCollapsibleOpen();

    collapsibleLayer?.classList.remove("is-active");
    collapsibleLayer?.setAttribute("aria-hidden", "true");

    collapsibleModals.forEach((modal) => {
      modal.classList.remove("active-container-la");
      modal.setAttribute("aria-hidden", "true");
    });

    collapsibleBtn.forEach((button) => {
      button.classList.remove("active-collapsible-la");
      button.setAttribute("aria-expanded", "false");
    });

    productSticky?.classList.remove("product-position-remove");
    activeCollapsibleTrigger = null;

    if (restoreScroll && wasOpen) {
      unlockProductPage();
    }
  };

  const openCollapsible = (trigger) => {
    const targetId = trigger.dataset.productCollapsibleTrigger;
    const modal = findCollapsibleModal(targetId);

    if (!modal) return;

    closeCollapsible({ restoreScroll: false });
    lockProductPage();

    collapsibleLayer?.classList.add("is-active");
    collapsibleLayer?.setAttribute("aria-hidden", "false");
    modal.classList.add("active-container-la");
    modal.setAttribute("aria-hidden", "false");
    trigger.classList.add("active-collapsible-la");
    trigger.setAttribute("aria-expanded", "true");
    activeCollapsibleTrigger = trigger;

    if (window.innerWidth <= 834) {
      productSticky?.classList.add("product-position-remove");
    }

    modal.querySelector(".x-icon-collapsible")?.focus();
  };

  collapsibleBtn.forEach((trigger) => {
    trigger.addEventListener("click", (e) => {
      e.stopPropagation();
      openCollapsible(trigger);
    });
  });

  closeButton.forEach((button) => {
    button.addEventListener("click", () => {
      const triggerToFocus = activeCollapsibleTrigger;
      closeCollapsible();
      triggerToFocus?.focus();
    });
  });

  document.addEventListener("keyup", (event) => {
    if (event.code.toUpperCase() === "ESCAPE" && isProductCollapsibleOpen()) {
      closeCollapsible();
    }
  });

  window.addEventListener("resize", () => {
    if (window.innerWidth > 834) {
      productSticky?.classList.remove("product-position-remove");
    }
  });

  if (textDescription) {
    const descriptionParagraphs = Array.from(textDescription.children).filter(
      (item) => item.tagName === "P"
    );
    const descriptionTitle = descriptionParagraphs.find((item) =>
      item.textContent.trim().toLowerCase().includes("description")
    );
    const descriptionText = descriptionTitle
      ? descriptionParagraphs[descriptionParagraphs.indexOf(descriptionTitle) + 1]
      : null;

    if (descriptionText) {
      const descriptionContent = document.createElement("span");
      const toggleButton = document.createElement("button");

      descriptionText.classList.add("product-description-toggle-wrapper-la");
      descriptionContent.id = "ProductDescriptionText-la";
      descriptionContent.className = "product-metafield-rich-text-la";

      while (descriptionText.firstChild) {
        descriptionContent.appendChild(descriptionText.firstChild);
      }

      toggleButton.id = "toggle-button-la";
      toggleButton.className = "text-description-more-la";
      toggleButton.type = "button";
      toggleButton.textContent = "View more";
      toggleButton.setAttribute("aria-controls", descriptionContent.id);
      toggleButton.setAttribute("aria-expanded", "false");

      descriptionText.append(descriptionContent, toggleButton);
      textDescription.classList.add("product-description-toggle-ready-la");

      toggleButton.addEventListener("click", () => {
        const isExpanded = descriptionContent.classList.toggle("expanded");
        toggleButton.textContent = isExpanded ? "View less" : "View more";
        toggleButton.setAttribute("aria-expanded", String(isExpanded));
      });
    }
  }
  let productDetailsSwiper = null;
  let productDetailsSliderStarted = false;
  const initProductDetailsSlider = () => {
    const productDetailsSlider = document.querySelector(".product-details-right");
    const isMobileDetailsSlider = window.innerWidth <= 834;

    if (!productDetailsSlider) return;

    if (isMobileDetailsSlider && !productDetailsSwiper) {
      ensureSwiperLa((SwiperCtor) => {
        if (productDetailsSwiper || window.innerWidth > 834) return productDetailsSwiper;

        productDetailsSwiper = new SwiperCtor(productDetailsSlider, {
          loop: true,
          slidesPerView: 1,
          spaceBetween: 20,
          autoplay: {
            delay: 4000,
            disableOnInteraction: false,
          },
          pagination: {
            el: ".swiper-product-details-slider",
            clickable: true,
          },
        });

        return productDetailsSwiper;
      });
      return;
    }

    if (!isMobileDetailsSlider && productDetailsSwiper) {
      productDetailsSwiper.destroy(true, true);
      productDetailsSwiper = null;
    }
  };

  const startProductDetailsSlider = () => {
    if (productDetailsSliderStarted) return;

    productDetailsSliderStarted = true;
    initProductDetailsSlider();
    window.addEventListener("resize", initProductDetailsSlider, { passive: true });
  };

  runWhenNear(".product-details-right", startProductDetailsSlider);
  const resetZoomImages = () => {
    imageZoom.forEach((el) => {
      if (window.innerWidth > 834) {
        el.style.transform = `scale(1.6) translate(-31.25%, -31.25%)`;
        el.style.left = "50%";
        el.style.top = "50%";
      } else {
        el.style.transform = `translate(-50%, -50%) scale(1)`;
        el.style.left = "50%";
        el.style.top = "50%";
      }
    });
  };

  let pendingZoomPlaybackState = null;
  let productImagesZoomSwiper = null;

  const getProductImagesZoomSwiper = () => {
    if (productImagesZoomSwiper) return productImagesZoomSwiper;
    if (!zoomItems) return null;
    if (!window.Swiper) return null;

    productImagesZoomSwiper = new window.Swiper(".product-zoom-la", {
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      breakpoints: {
        834: {
          allowTouchMove: false,
        },
      },
      on: {
        slideChange: function () {
          resetZoomImages();
        },
        slideChangeTransitionEnd: function () {
          handleZoomVideoPlayback(this, pendingZoomPlaybackState || {});
          pendingZoomPlaybackState = null;
        },
      },
    });

    return productImagesZoomSwiper;
  };

  const mobileMediaSlider = document.querySelector(".mobile-media-product-la");

  if (mobileMediaSlider) {
    if (window.innerWidth <= 1024) {
      runWhenNear(mobileMediaSlider, initMobileImagesSlider, "0px");
    }

    mobileMediaSlider.addEventListener("pointerdown", initMobileImagesSlider, {
      once: true,
      passive: true,
    });
    mobileMediaSlider.addEventListener("touchstart", initMobileImagesSlider, {
      once: true,
      passive: true,
    });
    mobileMediaSlider.addEventListener("focusin", initMobileImagesSlider, {
      once: true,
    });
  }

  runWhenNear(".swiper-slider-also-container-la", () => {
    ensureSwiperLa((SwiperCtor) => new SwiperCtor(".swiper-slider-also-container-la", {
      slidesPerView: "auto",
      spaceBetween: 8,
      navigation: {
        nextEl: ".swiper-button-next-also-with-la",
        prevEl: ".swiper-button-prev-also-with-la",
      },
    }));
  });

  runWhenNear(".swiper-slider-with-container-la", () => {
    ensureSwiperLa((SwiperCtor) => new SwiperCtor(".swiper-slider-with-container-la", {
      slidesPerView: "auto",
      spaceBetween: 8,
      navigation: {
        nextEl: ".swiper-button-next-also-with-la",
        prevEl: ".swiper-button-prev-also-with-la",
      },
    }));
  });
  itemProduct &&
    itemProduct.forEach((el) => {
      el.addEventListener("click", () => {
        ensureSwiperLa(() => {
          const zoomSwiper = getProductImagesZoomSwiper();
          if (!zoomSwiper) return;

          zoomItems.classList.add("zoom-active-la");
          bodyProduct.classList.add("bodyOverflow");

          let slideIndex = [...el.parentElement.children].indexOf(el);
          const sourceVideo = el.querySelector("video");

          pendingZoomPlaybackState = {
            currentTime:
              sourceVideo && Number.isFinite(sourceVideo.currentTime)
                ? sourceVideo.currentTime
                : null,
          };

          requestAnimationFrame(() => {
            zoomSwiper.update();
            zoomSwiper.slideTo(slideIndex, 0, false);

            requestAnimationFrame(() => {
              handleZoomVideoPlayback(
                zoomSwiper,
                pendingZoomPlaybackState || {}
              );
              pendingZoomPlaybackState = null;
            });
          });
        });
      });
    });

  function handleZoomVideoPlayback(swiper, options = {}) {
    document
      .querySelectorAll(".product-zoom-items-la video")
      .forEach((v) => {
        if (v.closest(".swiper-slide") !== swiper.slides[swiper.activeIndex]) {
          v.pause();
        }
      });

    document
      .querySelectorAll(".product-zoom-items-la iframe")
      .forEach((frame) => {
        if (frame.closest(".swiper-slide") !== swiper.slides[swiper.activeIndex]) {
          controlIframePlayback(frame, "pause");
        }
      });

    const activeSlide = swiper.slides[swiper.activeIndex];
    if (!activeSlide) return;

    const video = activeSlide.querySelector("video");
    const iframe = activeSlide.querySelector("iframe");

    if (video) {
      if (Number.isFinite(options.currentTime)) {
        const maxTime = Number.isFinite(video.duration)
          ? Math.max(video.duration - 0.1, 0)
          : options.currentTime;

        try {
          video.currentTime = Math.min(options.currentTime, maxTime);
        } catch (error) {
          console.log("Video sync error:", error);
        }
      }

      safePlayMedia(video);
    }

    if (iframe) {
      controlIframePlayback(iframe, "play");
    }
  }

  closeZoomModal &&
    closeZoomModal.addEventListener("click", () => {
      zoomItems.classList.remove("zoom-active-la");
      bodyProduct.classList.remove("bodyOverflow");
      resetZoomImages();
    });

  const handleDesktopZoom = (el) => {
    let zoomLevel = 1;
    let isDragging = false;
    let startX, startY, initialX, initialY;

    el.addEventListener("click", (e) => {
      if (isDragging) {
        isDragging = false;
        return;
      }
      if (zoomLevel === 1) {
        zoomLevel = 2;
        el.style.transform = `scale(2.2) translate(-22.72%, -22.72%)`;
        el.style.cursor = "zoom-in";
      } else if (zoomLevel === 2) {
        zoomLevel = 3;
        el.style.transform = `scale(3) translate(-16.66%, -16.66%)`;
        el.style.cursor = "zoom-out";
      } else {
        zoomLevel = 1;
        el.style.transform = `scale(1.6) translate(-31.25%, -31.25%)`;
        el.style.left = "50%";
        el.style.top = "50%";
        el.style.cursor = "zoom-in";
      }
    });

    el.addEventListener("mousedown", (e) => {
      e.preventDefault();
      isDragging = false;
      startX = e.clientX;
      startY = e.clientY;
      initialX = el.offsetLeft;
      initialY = el.offsetTop;
      document.addEventListener("mousemove", onMouseMove);
    });

    const onMouseMove = (e) => {
      const dx = e.clientX - startX;
      const dy = e.clientY - startY;

      if (Math.abs(dx) > 3 || Math.abs(dy) > 3) {
        isDragging = true;
      }

      if (zoomLevel === 2) {
        if (
          initialX + dx > window.innerWidth / 4.5 &&
          initialX + dx < window.innerWidth / 1.3
        ) {
          el.style.left = initialX + dx + "px";
        }
        if (
          initialY + dy > window.innerWidth / 7 &&
          initialY + dy < window.innerWidth / 3.3
        ) {
          el.style.top = initialY + dy + "px";
        }
      }
      if (zoomLevel === 3) {
        if (
          initialX + dx > window.innerWidth / 3.1 &&
          initialX + dx < window.innerWidth / 1.5
        ) {
          el.style.left = initialX + dx + "px";
        }
        if (
          initialY + dy > window.innerWidth / 9 &&
          initialY + dy < window.innerWidth / 3
        ) {
          el.style.top = initialY + dy + "px";
        }
      }
    };

    document.addEventListener("mouseup", () => {
      document.removeEventListener("mousemove", onMouseMove);
    });
  };

  const handleMobileZoom = (el) => {
    let zoomLevel = 1,
      initialDistance = 0;
    let translateX = 0,
      translateY = 0;
    let startX = 0,
      startY = 0;
    let isDragging = false,
      isPinching = false;
    let lastTap = 0;

    const container = el.parentElement;
    container.style.position = "relative";
    el.style.position = "absolute";
    el.style.top = "50%";
    el.style.left = "50%";
    el.style.transform = "translate(-50%, -50%) scale(1)";

    const clamp = (value, min, max) => Math.min(Math.max(value, min), max);

    const setTransform = (animate = false) => {
      el.style.transition = animate ? "transform 0.3s ease-out" : "none";

      const containerRect = container.getBoundingClientRect();

      const imgWidth = el.naturalWidth || el.offsetWidth;
      const imgHeight = el.naturalHeight || el.offsetHeight;

      const scaledWidth = imgWidth * zoomLevel;
      const scaledHeight = imgHeight * zoomLevel;

      const maxX = Math.max((scaledWidth - containerRect.width) / 2, 0);
      const maxY = Math.max((scaledHeight - containerRect.height) / 2, 0);

      translateX = clamp(translateX, -maxX, maxX);
      translateY = clamp(translateY, -maxY, maxY);

      el.style.transform =
        `translate(-50%, -50%) translate(${translateX}px, ${translateY}px) scale(${zoomLevel})`;

      if (productImagesZoomSwiper) {
        productImagesZoomSwiper.allowTouchMove = zoomLevel === 1;
      }
    };

    const getDistance = (touches) => {
      if (touches.length < 2) return 0;
      const dx = touches[1].clientX - touches[0].clientX;
      const dy = touches[1].clientY - touches[0].clientY;
      return Math.sqrt(dx * dx + dy * dy);
    };

    el.addEventListener("touchstart", (e) => {
      if (e.touches.length === 2) {
        isPinching = true;
        initialDistance = getDistance(e.touches);
        el.style.transition = "none";
        return;
      }

      if (isPinching) return;

      startX = e.touches[0].clientX - translateX;
      startY = e.touches[0].clientY - translateY;
      isDragging = true;

      const currentTime = new Date().getTime();
      const tapLength = currentTime - lastTap;
      lastTap = currentTime;

      if (tapLength < 300 && tapLength > 0) {
        zoomLevel = zoomLevel === 1 ? 2 : 1;
        translateX = 0;
        translateY = 0;
        setTransform(true);
        isDragging = false;
        return;
      }
    });

    el.addEventListener("touchmove", (e) => {
      if (zoomLevel > 1) {
        e.stopPropagation();
        e.preventDefault();
      }

      if (isPinching && e.touches.length === 2) {
        const newDistance = getDistance(e.touches);
        if (initialDistance > 0) {
          const scaleChange = newDistance / initialDistance;
          zoomLevel = Math.max(1, Math.min(3, zoomLevel * scaleChange));
        }
        initialDistance = newDistance;
        setTransform(false);
        return;
      }

      if (e.touches.length === 1 && isDragging && zoomLevel > 1) {
        translateX = e.touches[0].clientX - startX;
        translateY = e.touches[0].clientY - startY;
        setTransform(false);
      }
    });

    el.addEventListener("touchend", (e) => {
      if (e.touches.length === 0) {
        isPinching = false;
        isDragging = false;
      }

      if (zoomLevel === 1) {
        translateX = 0;
        translateY = 0;
      }
      setTransform(false);
    });
  };
  imageZoom &&
    imageZoom.forEach((el) => {
      if (window.innerWidth > 834) {
        handleDesktopZoom(el);
      } else {
        handleMobileZoom(el);
      }
    });
});
